export default class MultiSelect {
  constructor($module) {
    this.$module = $module;
    this.$control = this.$module.querySelector(".bc-multi-select__control");
    this.$panel = this.$module.querySelector(".bc-multi-select__panel");
    this.$checkboxes = this.$module.querySelectorAll(".bc-multi-select__input");
    this.isListOnly = this.$module.classList.contains("bc-multi-select--list-only");

    if (!this.$panel) {
      return;
    }

    this.bindEvents();
    this.syncOptionState();
    this.setOpenState(this.isOpen());
    this.updateControlLabel();
  }

  bindEvents() {
    if (this.$control && !this.$control.disabled) {
      this.$control.addEventListener("click", () => this.togglePanel());
    }

    this.$checkboxes.forEach((input) => {
      input.addEventListener("change", () => this.syncOptionState());
    });

    if (!this.isListOnly && this.$control) {
      document.addEventListener("click", (event) => {
        if (!this.isOpen()) {
          return;
        }

        if (!this.$module.contains(event.target)) {
          this.closePanel();
        }
      });

      this.$module.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          this.closePanel();
        }
      });
    }
  }

  syncOptionState() {
    let checkedCount = 0;

    this.$checkboxes.forEach((input) => {
      const option = input.closest(".bc-multi-select__option");
      if (!option) {
        return;
      }

      option.classList.toggle("bc-multi-select__option--checked", input.checked);
      option.classList.toggle("bc-multi-select__option--disabled", input.disabled);

      if (input.checked) {
        checkedCount += 1;
      }
    });

    this.$module.classList.toggle("bc-multi-select--filled", checkedCount > 0);
    this.updateControlLabel(checkedCount);
    this.emitChange();
  }

  updateControlLabel(checkedCount) {
    if (!this.$control) {
      return;
    }

    const labelEl = this.$control.querySelector(".bc-multi-select__control-label");
    if (!labelEl) {
      return;
    }

    const selectedCount = Number.isFinite(checkedCount)
      ? checkedCount
      : Array.from(this.$checkboxes).filter((input) => input.checked).length;
    const defaultLabel = this.$control.dataset.defaultLabel;

    if (!selectedCount) {
      labelEl.textContent = defaultLabel;
      return;
    }

    if (selectedCount === 1) {
      const selectedInput = Array.from(this.$checkboxes).find((input) => input.checked);
      const textEl = selectedInput
        ?.closest(".bc-multi-select__option")
        ?.querySelector(".bc-multi-select__text");
      labelEl.textContent = textEl ? textEl.textContent.trim() : "1 selected";
      return;
    }

    labelEl.textContent = `${selectedCount} selected`;
  }

  togglePanel() {
    if (!this.$control || this.$control.disabled) {
      return;
    }

    if (this.isOpen()) {
      this.closePanel();
    } else {
      this.openPanel();
    }
  }

  isOpen() {
    return this.$panel.classList.contains("bc-multi-select__panel--open");
  }

  openPanel() {
    this.setOpenState(true);
  }

  closePanel() {
    if (this.isListOnly) {
      return;
    }

    this.setOpenState(false);
  }

  setOpenState(isOpen) {
    this.$panel.classList.toggle("bc-multi-select__panel--open", isOpen);
    this.$panel.hidden = !isOpen;
    this.$module.classList.toggle("bc-multi-select--open", isOpen && !this.isListOnly);

    if (this.$control) {
      this.$control.setAttribute("aria-expanded", isOpen ? "true" : "false");
    }
  }

  emitChange() {
    const selectedValues = Array.from(this.$checkboxes)
      .filter((input) => input.checked)
      .map((input) => input.value);

    const inputName = this.$checkboxes[0]?.name || null;

    this.$module.dispatchEvent(
      new CustomEvent("multi-select:change", {
        bubbles: true,
        detail: {
          name: inputName,
          values: selectedValues
        }
      })
    );
  }
}
